<div md-dialog-content>{{confirmMessage}}</div>
<div md-dialog-actions class="container">
  <met-button (click)="closeWithValue(false)" buttonText="Nein"></met-button>
  <met-button (click)="closeWithValue(true)" buttonText="Ja"></met-button>
</div>